import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/companies/company_Id/Company_Id.tsx");
